import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Form as ReactForm, withContext } from '@rexlabs/react-forms';
import { styled, StyleSheet } from '@rexlabs/styling';
import { isString } from 'lodash';
var defaultStyles = StyleSheet({
  form: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    '& .form__field:first-child': {
      marginTop: 0
    }
  },
  formError: {
    color: 'red'
  }
});
var Form = (_dec = styled(defaultStyles), withContext(_class = _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, _getPrototypeOf(Form).apply(this, arguments));
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          s = _this$props.styles,
          name = _this$props.name,
          children = _this$props.children,
          FormError = _this$props.FormError,
          reactForms = _this$props.reactForms,
          rest = _objectWithoutProperties(_this$props, ["styles", "name", "children", "FormError", "reactForms"]);

      var touched = reactForms.touched,
          errors = reactForms.errors;

      var formErrorProps = _objectSpread({}, !isString(FormError) ? {
        touched: touched,
        errors: errors
      } : {});

      return React.createElement(ReactForm, _extends({}, rest, s('form'), {
        name: name,
        id: name,
        "data-form-name": name
      }), FormError && _Object$keys(errors).length > 0 && React.createElement(FormError, _extends({}, s('formError'), formErrorProps)), children);
    }
  }]);

  return Form;
}(Component), _defineProperty(_class2, "propTypes", {
  name: PropTypes.string,
  FormError: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
}), _temp)) || _class) || _class) || _class);
export default Form;